'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M20 16h2v-2h-2v2zm0-9v5h2V7h-2zM10 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 10c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z' });

var DiscFull = function DiscFull(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

DiscFull = (0, _pure2.default)(DiscFull);
DiscFull.muiName = 'SvgIcon';

exports.default = DiscFull;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/DiscFull.js
// module id = 2326
// module chunks = 0